import type { ActionContext } from 'vuex'

import type { CoreState } from '@/core/store/types'
import type { Location } from '@/core/types'
import { OlympusClient } from '@/OlympusClient'

export interface UpdateProcessingParams {
  locationId: string
  update: Location['processing']
}

export const updateLocationProcessing = async (
  { commit }: ActionContext<CoreState, unknown>,
  { locationId, update }: UpdateProcessingParams
): Promise<void> => {
  const location = await OlympusClient.locations.location.updateLocation({
    body: {
      processing: update,
    },
    params: {
      locationId,
    },
  })

  commit('SET_LOCATION', location)
}
